<template>
  <a-modal
    :visible="show"
    @cancel="$emit('close')">
    <h3 slot="title">
      <a-icon class="mr-2" type="cloud-download" />
      {{ $t('msg.office.export.title') }}
    </h3>
    <div class="mb-2">
      {{ $t('msg.office.export.subtitle1') }}
      <a-tooltip
        placement="right"
        :title="$t('msg.office.export.warning', { limit })"
        v-if="blocked">
        <a-icon
          type="exclamation-circle"
          class="text-danger font-size-14 ml-1" />
      </a-tooltip>
    </div>
    <div class="mt-3 mb-2">
      {{ $t('msg.office.export.subtitle2') }}
    </div>
    <a-input
      v-model="email"
      size="large"
      read-only />
    <div slot="footer" class="p-3">
      <a-button
        key="back"
        @click="onCancel">
        {{ $t('cancel') }}
      </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        :disabled="blocked"
        @click="onConfirm">
        {{ $t('export') }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import lms from '@/api/lms'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      limit: 5000,
      loading: false,
    }
  },
  computed: {
    email() {
      return this.$store.getters['session/USER'].email
    },
    blocked() {
      return false
    },
  },
  methods: {
    onConfirm() {
      this.loading = true
      const request = {
        type: 'OFFICES',
        email: this.email,
        filter: this.filters,
      }
      lms.office.exportOffices(request)
        .then(_ => {
          this.$emit('close')
          this.$router.push('/offices/exported')
        })
        .finally(() => (this.loading = false))
    },
    onCancel() {
      this.$emit('close')
    },
  },
}
</script>
